import { mapActions, mapGetters } from 'vuex';

import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

export default {
  REQUEST_LIFECYCLE,
  computed: {
    ...mapGetters('dashboard/reviews', [
      'reviewsKey',
      'getReviewsMetaByBucketName',
      'getRawReviewsByBucketName',
      'getRawReviewsAggregationByBucketName',
    ]),
    reviewsMeta () {
      return this.getReviewsMetaByBucketName(
        this.reviewsBucketName,
        this.reviewsKey
      );
    },
    rawReviews () {
      return this.getRawReviewsByBucketName(
        this.reviewsBucketName,
        this.reviewsKey
      );
    },
    rawReviewsAggregation () {
      return this.getRawReviewsAggregationByBucketName(
        this.reviewsBucketName,
        this.reviewsKey
      );
    },
  },
  methods: {
    ...mapActions('dashboard/reviews', [
      'fetchReviews',
      'createReview',
      'resetReviews',
    ]),
  },
};
